module.exports = __webpack_public_path__ + "img/groupofpeople.27e42b40.webp";